<template>
  <div class="container">
    <div class="container_content">
      <div id="title_container">{{ tituloContainer }}</div>
      <div v-if="isText" class="container_text">
        <div id="title_tecnologia">{{ tituloTecnologia }}</div>
        <div class="container-buttons">
          <div class="container-button">
            <q-btn
              @click="abrir_ficha_tecnologia"
              class="buttonoscuro"
              style="width: 100%"
              disabled
              >Ver ficha tecnología</q-btn
            >
          </div>
        </div>
        <div class="container-buttons">
          <div v-show="downloadPdf" class="container-button">
            <q-btn
              @click="ver_pdf()"
              class="buttonoscuro"
              style="width: 100%"
              >Ver informe</q-btn
            >
          </div>
        </div>
        <div class="container-buttons">
          <div v-show="showOffer" class="container-button">
            <form ref="form" @reset.prevent.stop="onReset">
              <q-dialog v-model="open" persistent>
                <q-card style="min-width: 400px, min-height: 200px">
                  <q-card-section>
                    <div class="text-h7">Introduzca el precio ofertado (€)</div>
                  </q-card-section>
                  <q-card-section>
                    <div class="flex-item_80">
                      <q-input
                        ref="ofertado"
                        v-model="ofertado"
                        type="number"
                        style="width: 100%"
                        lazy-rules
                        :rules="[
                          (val) =>
                            (/^[0-9]+(\.[0-9]{1,2})?$/.test(val) &&
                              val != '' &&
                              val > 0) ||
                            'Precio ofertado incorrecto ',
                        ]"
                      />
                    </div>
                  </q-card-section>
                  <q-card-actions align="right" class="text-primary">
                    <q-btn
                      flat
                      class="buttonoscuro"
                      label="OFERTAR"
                      type="reset"
                      @click="guardar_ofertado()"
                    />
                    <q-btn flat icon="close" v-close-popup />
                  </q-card-actions>
                </q-card>
              </q-dialog>
            </form>
            <q-btn
              title="Ofertar"
              @click="mostrar_ofertar"
              style="width: 100%"
              class="buttonoscuro"
              v-show="mostrar_btn_ofertar()"
              >OFERTAR</q-btn
            >
          </div>
        </div>
        <br />
        <q-card-section align="left">
          <div id="title_container">Presupuesto generado por:</div>
          <br />
          <div class="datos_propietario">{{ propietario_nombre_completo }}</div>
          <div class="datos_propietario">{{ propietario_email }}</div>
          <div class="datos_propietario">{{ propietario_empresa }}</div>
          <div class="datos_propietario">{{ propietario_telefono }}</div>
        </q-card-section>
      </div>
      <div v-else class="container_graficas">
        <div id="title_container_graficas">
          <span
            >{{ formato_numero_I(diferenciaDatos.number) }}
            {{ diferenciaDatos.type }}</span
          >
          <span class="resalt">{{ diferenciaDatos.txtInfoTitulo }}</span>
        </div>
        <div class="comp_flex-container-grafica">
          <div class="estruct_graf" ref="chartdiv"></div>
        </div>
        <div id="txt-bottom">
          <span v-html="diferenciaDatos.fraseFinal"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from '@/modules/amcharts4/core';
import * as am4charts from '@/modules/amcharts4/charts';
import am4themesAnimated from '@/modules/amcharts4/themes/animated';
import am4langesES from '@/modules/amcharts4/lang/es_ES';
import { QDialog } from 'quasar';

// Themes begin
am4core.useTheme(am4themesAnimated);

export default {
  data () {
    return {
      estado_id: 0,
      open: false,
      ofertado: null
    };
  },
  props: {
    tituloContainer: String,
    tituloTecnologia: String,
    propietario_nombre_completo: String,
    propietario_email: String,
    propietario_empresa: String,
    propietario_telefono: String,
    isText: String,
    dataArray: Object,
    dataGrafica: Array,
    typeContainer: String,
    url: String,
    downloadPdf: String,
    showOffer: String,
    tituloPresupuesto: String,
    showOfferEstadoPresupuesto: String
  },
  updated () {
    this.genera_graf();
  },
  methods: {
    mostrar_btn_ofertar () {
      if (
        this.$store.getters['TSZ/rolAplicacion'] === 2 &&
        (this.showOfferEstadoPresupuesto === 3 ||
          this.showOfferEstadoPresupuesto === 4)
      ) {
        return true;
      } else return false;
    },

    mostrar_ofertar () {
      this.open = true;
      this.onReset();
    },

    ocultar_ofertar () {
      this.open = false;
      this.onReset();
    },

    onReset () {
      this.ofertado = null;
      this.$refs.form.reset();
    },

    guardar_ofertado () {
      var idPresupuesto;

      if (this.ofertado === '' || this.ofertado === null || this.ofertado < 1) {
        this.mostrar_mensaje(
          'Debe introducir un precio ofertado correcto',
          'red'
        );
      } else {
        if (
          !(
            this.$route.params.PresupuestoId === 0 ||
            this.$route.params.PresupuestoId === null
          )
        ) { idPresupuesto = this.$store.getters['TSZ/idComparativa']; } else idPresupuesto = this.$route.params.PresupuestoId;

        let request = {
          controller: '/Presupuestos/' + idPresupuesto + '/Ofertar',
          filter: {},
          data: {
            email: this.$store.getters['TSZ/userMail']
          },
          body: {
            PrecioOfertado: this.ofertado
          }
        };

        this.$store
          .dispatch('TSZ/comparativaOfertar', request)
          .then((response) => {
            this.mostrar_mensaje(
              'Precio ofertado guardado correctamente',
              'green'
            );

            this.ocultar_ofertar();
          })
          .catch((err) => {
            console.log('ERR:' + err);
            this.$store.commit('TSZ/setOffline', false);
            let mensaje = 'Se ha producido un error: ' + err.response.data;
            this.mostrar_mensaje(mensaje);
          });
      }
    },

    mostrar_mensaje (text, color, timeout = 5000) {
      this.$q.notify({
        message: text,
        color: color,
        icon: 'warning',
        timeout: timeout,
        position: 'top-right',
        progress: true,
        actions: [{ icon: 'close', color: 'white' }]
      });
    },

    ver_pdf () {
      let idPresupuesto;

      if (
        !(
          this.$route.params.PresupuestoId === 0 ||
          this.$route.params.PresupuestoId === null
        )
      ) {
        idPresupuesto = this.$store.getters['TSZ/idComparativa'];
      } else {
        idPresupuesto = this.$route.params.PresupuestoId;
      }

      let pdfBase64 = '';
      let filename = this.tituloPresupuesto + '.pdf';

      let request = {
        controller: '/Presupuestos/' + idPresupuesto + '/Informe',
        filter: {},
        data: {
          email: this.$store.getters['TSZ/userMail']
        }
      };

      this.$store
        .dispatch('TSZ/getDatosTSZ_Listado_PDF', request)
        .then((response) => {
          pdfBase64 = response.data.Data.Base64;
          const link = document.createElement('a');
          link.href = 'data:application/pdf;base64,' + pdfBase64;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((err) => {
          this.showError(err);

          this.isLoadingDatos = false;
        });
    },
    abrir_ficha_tecnologia () {
      window.open(this.url, '_blank');
    },
    genera_graf () {
      am4core.options.commercialLicense = true;
      let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
      let categorias = ['Con Zanja', 'Sin Zanja'];

      let data = [];
      chart.data = [];

      chart.responsive.enabled = true;

      for (let i = 0; i < categorias.length; i++) {
        data.push({
          category: categorias[i],
          value: this.dataGrafica[i],
          color: am4core.color('#67D2DF')
        });
      }

      // Create axes
      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'category';
      categoryAxis.renderer.labels.template.horizontalCenter = 'right';
      categoryAxis.renderer.labels.template.fontWeight = 800;
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.fill = am4core.color('black');

      var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      // Create series
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.labels.template.disabled = true;

      var series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueX = 'value';
      series.dataFields.categoryY = 'category';

      series.columns.template.tooltipText =
        '{category}: [bold]{valueX} ' + this.diferenciaDatos.type + ' [/]';

      var valueLabel = series.bullets.push(new am4charts.LabelBullet());
      valueLabel.label.text = '{valueX} ' + this.diferenciaDatos.type;
      valueLabel.label.horizontalCenter = 'left';
      valueLabel.label.dx = 150;
      valueLabel.locationX = 1;
      valueLabel.strokeWidth = 0;
      valueLabel.label.hideOversized = false;
      valueLabel.label.truncate = false;

      series.name = 'xxxxxxxxxxxx';
      series.columns.template.propertyFields.fill = 'color';
      series.columns.template.column.stroke = am4core.color('#fff');
      chart.language.locale = am4langesES;

      if (this.typeContainer != 'tiempo_ejecucion') {
        chart.numberFormatter.numberFormat = '#,###.00';
      }

      chart.data = data;
    },
    formato_numero (value) {
      value = Math.abs(value);
      if (value == null || value == 0) {
        value = 0;
        return value.toFixed(2).replace('.', ',');
      } else {
        let val = (value / 1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    },

    formato_numero_I (value) {
      value = Math.abs(value);
      if (this.typeContainer == 'tiempo_ejecucion') {
        return value;
      } else {
        if (value == null || value == 0) {
          value = 0;
          return value.toFixed(2).replace('.', ',');
        } else {
          let val = (value / 1).toFixed(2).replace('.', ',');
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        }
      }
    }
  },
  computed: {
    nameGrafica () {
      return 'chartdiv-' + this._uid;
    },
    diferenciaDatos () {
      let typeContainer = this.typeContainer;

      let tcz = this.dataArray.tcz;
      let tsz = this.dataArray.tsz;
      let result = 0;
      let stringDataTitulo = '';
      let stringDataBottom = '';
      let typeSymbol = '';
      let fraseFinal = '';

      result = tcz - tsz;

      switch (typeContainer) {
        case 'coste':
          stringDataTitulo = ' más caro';
          stringDataBottom = 'Aumentamos ';
          if (result > 0) {
            stringDataTitulo = ' más barato';
            stringDataBottom = 'Reducimos ';
          }

          fraseFinal =
            '<span class="resalt">' +
            stringDataBottom +
            '</span> un <b>' +
            this.formato_numero(Math.abs(this.dataArray.tsz_porcent)) +
            '%</b> el coste de la actuación';

          typeSymbol = '€';
          break;
        case 'tiempo_ejecucion':
          stringDataTitulo = ' después';
          stringDataBottom = 'Aumentamos ';
          if (result > 0) {
            stringDataTitulo = ' antes';
            stringDataBottom = 'Reducimos ';
          }

          fraseFinal =
            '<span class="resalt">' +
            stringDataBottom +
            '</span> un <b>' +
            this.formato_numero(Math.abs(this.dataArray.tsz_porcent)) +
            '%</b> el plazo de ejecución';

          typeSymbol = 'días';
          break;
        case 'CO2':
          stringDataTitulo = ' más';
          stringDataBottom = 'Aumentamos ';
          if (result > 0) {
            stringDataTitulo = ' menos';
            stringDataBottom = 'Reducimos ';
          }

          fraseFinal =
            '<span class="resalt">' +
            stringDataBottom +
            '</span> las emisiones de gases contaminantes en un <b>' +
            this.formato_numero(Math.abs(this.dataArray.tsz_porcent)) +
            '%</b>';

          typeSymbol = 't';
          break;
        case 'escombros':
          stringDataTitulo = ' más';
          stringDataBottom = ' más ';
          if (result > 0) {
            stringDataTitulo = ' menos';
            stringDataBottom = ' menos ';
          }

          fraseFinal =
            'Generamos un <b>' +
            this.formato_numero(Math.abs(this.dataArray.tsz_porcent)) +
            '%</b> <span class="resalt">' +
            stringDataBottom +
            '</span> de escombros ';

          typeSymbol = 'm³';
          break;
        case 'ruido':
          stringDataTitulo = ' más';
          stringDataBottom = ' más ';
          if (result > 0) {
            stringDataTitulo = ' menos';
            stringDataBottom = ' menos ';
          }

          fraseFinal =
            'Provocamos un <b>' +
            this.formato_numero(Math.abs(this.dataArray.tsz_porcent)) +
            '%</b> <span class="resalt">' +
            stringDataBottom +
            '</span> de ruido durante la duración total de la obra';
          typeSymbol = 'dB/día';
          break;
        default:
          break;
      }

      let data = {
        number: result,
        type: typeSymbol,
        txtInfoTitulo: stringDataTitulo,
        txtInfoBottom: stringDataBottom,
        fraseFinal: fraseFinal
      };

      return data;
    }
  },
  components: {
    QDialog
  }
};
</script>

<style lang="scss">
$azulHover: #225eac;
$azuloscuro: #002f6c;
$azuloclaro: #878b97;

.buttonoscuro {
  background-color: $azuloscuro !important;
  border: none;
  color: #fff;
  font-weight: bold;
  line-height: 1.14;
  letter-spacing: 1.25px;
  font-size: 14px;
  &:hover {
    background-color: $azulHover !important;
    color: #fff;
  }
}

.buttonclaro {
  border: 1px solid #002f6c;
  color: #002f6c;
  font-weight: bold;
  line-height: 1.14;
  letter-spacing: 1.25px;
  font-size: 14px;
  &:hover {
    background-color: $azuloscuro !important;
    color: #fff;
  }
}

.buttonoscurodisabled {
  opacity: 0.18;
  border-radius: 4px;
  background-color: #979797;
  color: $azuloscuro;
  font-weight: bold;
  line-height: 1.14;
  letter-spacing: 1.25px;
  font-size: 14px;
}

.wrapper-page {
  background-color: #ececec !important;
}

.container {
  /*width: 390px;*/
  min-height: 485px;

  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12),
    0 1px 1px 0 rgba(0, 0, 0, 0.14);
  background-color: #ffffff;
}

.container_content {
  padding: 20px;
}

.container_graficas {
  padding-top: 5px;
}

#title_container {
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #313b44;
}

#title_tecnologia {
  margin-top: 21px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #313b44;
}

#title_container_graficas {
  font-family: Roboto;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #313b44;
}

.resalt {
  color: $azuloscuro;
  font-weight: bold;
}

#txt-bottom {
  font-family: Roboto;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #313b44;
}

.container-buttons {
  padding-top: 15px;
  display: flex;
  justify-content: space-left;
  width: 100%;
  height: 60px;
}

.container-button {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 60%;
}

.datos_propietario {
  color: rgb(65, 64, 64);
  font-size: 15px;
}
</style>
